<!-- 运营-编辑 -->

<template>
  <div class="operation-edit-dialog">
    <w-dialog ref="dialogRef" title="详情" width="60%" top="10vh" @wConfirm="handleSure">
      <el-row :gutter="40">
        <el-col :span="9">
          <div class="flex-btw align-center">
            <w-title :title_name="'出车详情'"></w-title>
            <div>{{ infoData.car_records.time }}</div>
          </div>

          <div class="outward-run">
            <div class="flex align-center remain-seats">
              <img src="@/assets/img/seat.png" class="outward-img" />
              <div>剩余座位：{{ infoData.car_records.available_count }}</div>
            </div>

            <div v-if="isEditInfo" class="m-m-t">
              <el-form class="edit-info-form" ref="editFormRef" :model="editForm" :rules="editFormRules"
                :label-width="90" label-position="left">
                <el-form-item label="车牌：" prop="car_id">
                  <el-select v-model="editForm.car_id" placeholder="请选择司机" filterable
                    :disabled="infoData.car_records.status == 2">
                    <el-option v-for="item in carOptions" :key="item.id" :label="item.plate" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="路线：" prop="route">
                  <el-input v-model="editForm.route" placeholder="请输入路线" disabled></el-input>
                </el-form-item>
                <el-form-item label="发车时间：" prop="departure_time">
                  <el-date-picker v-model="editForm.departure_time" type="datetime" placeholder="请选择发车时间"
                    format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm"
                    :disabled="infoData.car_records.status == 2" />
                </el-form-item>
                <el-form-item label="预计抵达：" prop="arrival_time">
                  <el-date-picker v-model="editForm.arrival_time" type="datetime" placeholder="请选择抵达时间"
                    format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" />
                </el-form-item>
                <el-form-item label="途经点：" prop="stopover_place">
                  <el-input v-model="editForm.stopover_place" placeholder="-" disabled></el-input>
                </el-form-item>
                <el-form-item label="乘车人数：" prop="count">
                  <el-input v-model="editForm.count" type="number" placeholder="请输入乘车人数" disabled></el-input>
                </el-form-item>
                <el-form-item label="司机：" prop="driver">
                  <el-select v-model="editForm.driver" :remote-method="getDriverOptions" filterable remote
                    placeholder="请选择司机" :disabled="infoData.car_records.status == 2">
                    <el-option v-for="item in driverOptions" :key="item.u_id" :label="item.u_name" :value="item.u_id" />
                  </el-select>
                </el-form-item>
              </el-form>
            </div>

            <div v-else class="m-m-t">
              <div class="flex align-center">
                <div class="left-title">车牌：</div>
                <div class="left-content">{{ infoData.car_records.car_plate }}</div>
              </div>
              <div class="flex align-center s-m-t">
                <div class="left-title">路线：</div>
                <div class="left-content">{{ infoData.car_records.departure_place }} - {{
                  infoData.car_records.arrival_place }}</div>
              </div>
              <div class="flex align-center s-m-t">
                <div class="left-title">发车时间：</div>
                <div class="left-content">{{ infoData.car_records.departure_time }}</div>
              </div>
              <div class="flex align-center s-m-t">
                <div class="left-title">预计抵达：</div>
                <div class="left-content">{{ infoData.car_records.arrival_time }}</div>
              </div>
              <div class="flex align-center s-m-t">
                <div class="left-title">途经点：</div>
                <div class="left-content">{{ infoData.car_records.stopover_place ? infoData.car_records.stopover_place :
                  '-' }}</div>
              </div>
              <div class="flex align-center s-m-t">
                <div class="left-title">乘车人数：</div>
                <div class="left-content">{{ infoData.car_records.count }}</div>
              </div>
              <div class="flex align-center s-m-t">
                <div class="left-title">司机：</div>
                <div class="left-content">{{ infoData.car_records.driver_name }}</div>
              </div>
            </div>

            <div class="text-center" v-if="isEditInfo">
              <el-button plain round @click="onConfirmModify">确认修改</el-button>
            </div>
            <div v-else class="flex align-center add-btn s-m-t">
              <el-icon>
                <EditPen />
              </el-icon>
              <div class="add-text" @click="onEditInfo">编辑基本信息</div>
            </div>
          </div>
        </el-col>
        <el-col :span="15">
          <div class="flex-btw align-center">
            <div class="flex align-center">
              <w-title :title_name="'乘车记录'"></w-title>
              <div>（共计{{ infoData.car_records_list.length }}条）</div>
            </div>
            <div class="flex ">
              <div class="flex align-center add-btn">
                <el-icon>
                  <CirclePlusFilled />
                </el-icon>
                <div class="add-text" @click="onAddSystemBtn">继续添加系统预约</div>
              </div>
              <div class="flex align-center add-btn margin-left-10">
                <el-icon>
                  <CirclePlusFilled />
                </el-icon>
                <div class="add-text" @click="onAddBtn">继续添加营销用车</div>
              </div>
            </div>

          </div>

          <common-table ref="tableRef" tableHeight="500" :columns="tableColumns" :ispaging="false"
            :tableData="infoData.car_records_list" @onDelete="onDelete">
            <!-- 修改 -->
            <template #edit="{ scope }">
              <template v-if="scope.row.order_id == 0 && scope.row.can_edit == 1">
                <el-button @click="onEditBtn(scope.row, scope.$index)">编辑</el-button>
              </template>
            </template>
          </common-table>
        </el-col>
      </el-row>
    </w-dialog>

    <!-- 补充乘客 -->
    <w-dialog ref="supplementRef" :title="isEdit ? '编辑' : '补充乘客'" width="30%" top="10vh"
      :confirmText="isEdit ? '确认修改' : '确认添加'" @wConfirm="onSuresupplement">
      <el-form ref="formRef" :model="ruleForm" :rules="formRules" labelPosition="top">
        <el-form-item v-if="showSystemOrderLists" label="订单编号" prop="order_id">
          <div class="order-search-container">
            <div class="search-input-wrapper">
              <el-icon class="search-icon">
                <Search />
              </el-icon>
              <el-input v-model="orderSearchKeyword" placeholder="请输入订单编号进行查询" class="order-search-input"
                @input="handleOrderSearch" @focus="showSystemOrderListsTable = true" clearable />
            </div>
            <div class="order-table-container" v-if="showSystemOrderListsTable">
              <el-table :data="filteredOrderList" height="300" @row-click="handleOrderSelect" highlight-current-row
                class="order-selection-table">
                <el-table-column prop="or_sn" show-overflow-tooltip label="订单编号" width="80" />
                <el-table-column prop="mcr_name" show-overflow-tooltip label="路线名称" width="80" />
                <el-table-column prop="oc_contact_people" show-overflow-tooltip label="约车人" width="80" />
                <el-table-column prop="oc_contact_tel" label="联系电话" width="80" />
                <el-table-column prop="oc_number" label="乘车人数" width="80" />
              </el-table>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="乘车人数" prop="count">
          <el-input v-model="ruleForm.count" type="number" placeholder="请输入乘车人数" clearable
            oninput="if(value<1)value=1"></el-input>
        </el-form-item>
        <el-form-item label="约车人" prop="contact_name">
          <el-input v-model="ruleForm.contact_name" placeholder="请输入约车人" clearable></el-input>
        </el-form-item>
        <el-form-item label="约车人电话" prop="contact_mobile">
          <el-input v-model="ruleForm.contact_mobile" placeholder="请输入约车人电话" clearable></el-input>
        </el-form-item>
        <el-form-item label="上车点" prop="departure_place">
          <el-input v-model="ruleForm.departure_place" placeholder="请输入上车点" clearable></el-input>
        </el-form-item>
        <el-form-item label="下车点" prop="arrival_place">
          <el-input v-model="ruleForm.arrival_place" placeholder="请输入下车点" clearable></el-input>
        </el-form-item>
      </el-form>
    </w-dialog>
  </div>
</template>

<script>
import { ref, nextTick, } from "vue";
import { VipApi, } from "@/plugins/api.js";
import { CirclePlusFilled, EditPen, Search, } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";

export default {
  emits: ["submit",],
  components: { CirclePlusFilled, EditPen, Search, },
  setup(props, { emit }) {
    const dialogRef = ref(null);  // 弹框对象
    const currentRow = ref('');  // 当前行数据
    const infoData = ref({});  // 详情数据
    const tableRef = ref(null);  // 表格对象
    /** 表格配置数据 */
    const tableColumns = ref([
      {
        prop: "contact_name",
        label: "约车人",
      },
      {
        prop: "contact_mobile",
        label: "联系电话",
      },
      {
        prop: "count",
        label: "乘车人数",
      },
      {
        prop: "source_text",
        label: "数据来源",
      },
      {
        prop: "departure_place",
        label: "上车点",
      },
      {
        prop: "arrival_place",
        label: "下车点",
      },
      {
        type: "operation",
        prop: "",
        label: "操作",
        minWidth: 190,
        bottons: [
          {
            name: "编辑",
            action: "edit",
            type: "customRender",
          },
          {
            name: "删除",
            action: "onDelete",
            token: "n_39866a6c0ecde97b77225e3f5",
            HiddenKey: "can_delete",
            showValue: [1],
            className: "error-font-btn",
          },
        ],
      },
    ]);
    const carOptions = ref([]);  // 车辆列表
    const isEditInfo = ref(false);  // 是否编辑基本信息
    const basicDatas = ref({});  // 编辑基本信息数据
    const editFormRef = ref(null);  // 编辑表单对象
    const editForm = ref({
      car_id: '',  // 车辆ID
      car_plate: '',  // 车牌
      route: '',  // 路线
      departure_time: '',  // 出发时间
      arrival_time: '', // 到达时间
      stopover_place: '', // 途经点
      count: '',  // 乘车人数
      driver: '',  // 司机
    });
    const editFormRules = {
      car_plate: [{ required: true, message: "请选择车牌", trigger: "change" },],
      route: [{ required: true, message: "请输入路线", trigger: "blur" },],
      departure_time: [{ required: true, message: "请选择发车时间", trigger: "change" },],
      arrival_time: [{ required: true, message: "请选择抵达时间", trigger: "change" },],
      count: [{ required: true, message: "请输入乘车人数", trigger: "blur" },],
      driver: [{ required: true, message: "请选择司机", trigger: "change" },],
    };
    const driverOptions = ref([]); // 司机列表
    const isEdit = ref(false);  // 是否编辑乘车记录
    const editIndex = ref(0);  // 编辑下标
    const supplementRef = ref(null);  // 补充乘客弹框对象
    const formRef = ref(null);  //表单
    const ruleForm = ref({
      count: '',  // 乘车人数
      contact_name: '',  // 约车人
      contact_mobile: '', // 约车人电话
      departure_place: '',  // 上车点
      arrival_place: '',  // 下车点
      order_id: '',  // 订单编号
    });
    const formRules = {
      count: [{ required: true, message: "请输入乘车人数", trigger: "blur" },],
      contact_name: [{ required: true, message: "请输入约车人", trigger: "blur" },],
      contact_mobile: [{ required: true, message: "请输入约车人电话", trigger: "blur" },],
      departure_place: [{ required: true, message: "请输入上车点", trigger: "blur" },],
      arrival_place: [{ required: true, message: "请输入下车点", trigger: "blur" },],
    };

    /**
     * 
     * 打开对话框
     * 
     * **/
    const openDialog = (row) => {
      currentRow.value = row;
      getDetailsData();
    }
    /**
     * 
     * 关闭对话框
     * 
     * **/
    const closeDialog = () => {
      dialogRef.value.close();
    }
    /**
     * 
     * 关闭对话框加载状态
     * 
     * **/
    const closeDialogLoading = () => {
      dialogRef.value.isLoading = false;
    }

    /**
     * 
     * 获取详情数据
     * 
     * **/
    const getDetailsData = () => {
      VipApi.getCarRecordsDetail({ id: currentRow.value.id, }).then((res) => {
        if (res.Code == 200) {
          isEditInfo.value = false;
          dialogRef.value.show();
          res.Data.car_records.time = res.Data.car_records.departure_time.split(' ')[0];
          infoData.value = res.Data;
          console.log(infoData.value);
          basicDatas.value = {
            car_id: res.Data.car_records.car_id,
            car_plate: res.Data.car_records.car_plate,
          };
          nextTick(() => {
            tableRef.value.tableLoad();
          })
        }
      });
    }
    /**
     * 
     * 编辑基本信息
     * 
     * **/
    const onEditInfo = () => {
      isEditInfo.value = !isEditInfo.value;
      if (isEditInfo.value) {
        getAvailableCarList();
        driverOptions.value = [];
        editForm.value.car_id = infoData.value.car_records.car_id;
        editForm.value.car_plate = infoData.value.car_records.car_plate;
        editForm.value.route = infoData.value.car_records.departure_place + ' - ' + infoData.value.car_records.arrival_place;
        editForm.value.departure_time = infoData.value.car_records.departure_time;
        editForm.value.arrival_time = infoData.value.car_records.arrival_time;
        editForm.value.stopover_place = infoData.value.car_records.stopover_place;
        editForm.value.count = infoData.value.car_records.count;
        editForm.value.driver = infoData.value.car_records.driver_name;
      }
    }
    /**
     * 
     * 获取可用车辆列表
     * 
     * **/
    const getAvailableCarList = () => {
      VipApi.getAvailableCarList({ req_type: 3, }).then((res) => {
        if (res.Code == 200) {
          res.Data.unshift({ id: basicDatas.value.car_id, plate: basicDatas.value.car_plate, });
          carOptions.value = res.Data;
        }
      });
    }
    /**
     * 
     * 获取司机
     * 
     * **/
    const getDriverOptions = (query) => {
      VipApi.searchCarDiver({ keyword: query, }).then((res) => {
        if (res.Code == 200) {
          driverOptions.value = res.Data;
        }
      });
    }
    /**
     * 
     * 确认修改
     * 
     * **/
    const onConfirmModify = () => {
      editFormRef.value.validate((valid) => {
        if (valid) {
          // 查找车牌下标
          const carIndex = carOptions.value.findIndex(item => item.id == editForm.value.car_id);
          infoData.value.car_records.car_id = carOptions.value[carIndex].id;
          infoData.value.car_records.car_plate = carOptions.value[carIndex].plate;
          infoData.value.car_records.departure_time = editForm.value.departure_time;
          infoData.value.car_records.arrival_time = editForm.value.arrival_time;
          infoData.value.car_records.stopover_place = editForm.value.stopover_place;
          if (driverOptions.value.length > 0) {
            const driverIndex = driverOptions.value.findIndex(item => item.u_id == editForm.value.driver);
            infoData.value.car_records.driver = driverOptions.value[driverIndex].u_id;
            infoData.value.car_records.driver_name = driverOptions.value[driverIndex].u_name;
          }
          isEditInfo.value = false;
        }
      });
    }
    const showSystemOrderLists = ref(false);
    const systemOrderLists = ref([]);
    const orderSearchKeyword = ref(''); // 订单搜索关键词
    const filteredOrderList = ref([]); // 过滤后的订单列表

    /**
     * 处理订单搜索
     */
    const handleOrderSearch = (value) => {
      if (!value) {
        filteredOrderList.value = systemOrderLists.value;
        return;
      }
      filteredOrderList.value = systemOrderLists.value.filter(item =>
        item.or_sn.includes(value)
      );
    }

    /**
     * 处理订单选择
     */
    const handleOrderSelect = (row) => {
      ruleForm.value.order_id = row.or_id;
      orderSearchKeyword.value = row.or_sn;
      ruleForm.value.contact_name = row.oc_contact_people || '';
      ruleForm.value.contact_mobile = row.oc_contact_tel || '';
      ruleForm.value.count = row.oc_number || '';
      ruleForm.value.departure_place = row.mcr_start_place || '';
      ruleForm.value.arrival_place = row.mcr_end_place || '';
      showSystemOrderListsTable.value = false;
    }

    const onAddSystemBtn = async () => {
      const res = await VipApi.getSystemOrderLists({
        member_id: currentRow.value.id,
        page: 1,
        page_size: 10000,
      })
      if (res.Code == 200) {
        systemOrderLists.value = res.Data.list;
        filteredOrderList.value = res.Data.list; // 初始化过滤列表
      }
      ruleForm.value.order_id = ''
      ruleForm.value.count = '';
      ruleForm.value.contact_name = '';
      ruleForm.value.contact_mobile = '';
      ruleForm.value.departure_place = infoData.value.car_records.departure_place;
      ruleForm.value.arrival_place = infoData.value.car_records.arrival_place;
      isEdit.value = false;
      showSystemOrderLists.value = true;
      orderSearchKeyword.value = ''; // 重置搜索关键词
      supplementRef.value.show();
    }
    /**
     * 
     * 乘车记录-继续添加
     * 
     * **/
    const onAddBtn = () => {
      ruleForm.value.order_id = ''
      ruleForm.value.count = '';
      ruleForm.value.contact_name = '';
      ruleForm.value.contact_mobile = '';
      ruleForm.value.departure_place = infoData.value.car_records.departure_place;
      ruleForm.value.arrival_place = infoData.value.car_records.arrival_place;
      isEdit.value = false;
      showSystemOrderLists.value = false;
      supplementRef.value.show();
    }
    /**
     * 
     * 乘车记录-编辑按钮
     * 
     * **/
    const onEditBtn = (row, i) => {
      editIndex.value = i;
      ruleForm.value.count = row.count;
      ruleForm.value.contact_name = row.contact_name;
      ruleForm.value.contact_mobile = row.contact_mobile;
      ruleForm.value.departure_place = row.departure_place;
      ruleForm.value.arrival_place = row.arrival_place;
      isEdit.value = true;
      supplementRef.value.show();
    }
    /**
     * 
     * 乘车记录-确认补充
     * 
     * **/
    const onSuresupplement = () => {
      formRef.value.validate((valid) => {
        if (valid) {
          supplementRef.value.isLoading = true;
          if (isEdit.value) {
            // 编辑
            infoData.value.car_records_list[editIndex.value] = {
              id: infoData.value.car_records_list[editIndex.value].id,
              can_edit: infoData.value.car_records_list[editIndex.value].can_edit,
              can_delete: infoData.value.car_records_list[editIndex.value].can_delete,
              order_id: ruleForm.value.order_id || 0,
              source_text: ruleForm.value.order_id ? '系统预约' : '手动添加',
              contact_name: ruleForm.value.contact_name,
              contact_mobile: ruleForm.value.contact_mobile,
              count: ruleForm.value.count,
              departure_place: ruleForm.value.departure_place,
              arrival_place: ruleForm.value.arrival_place,
            };
          } else {
            // 新增
            infoData.value.car_records_list.push({
              id: 0,
              order_id: ruleForm.value.order_id || 0,
              can_edit: 1,
              can_delete: 1,
              source_text: ruleForm.value.order_id ? '系统预约' : '手动添加',
              contact_name: ruleForm.value.contact_name,
              contact_mobile: ruleForm.value.contact_mobile,
              count: ruleForm.value.count,
              departure_place: ruleForm.value.departure_place,
              arrival_place: ruleForm.value.arrival_place,
            });
          }

          editForm.value.count = 0;
          infoData.value.car_records.count = 0;
          if (infoData.value.car_records_list.length > 0) {
            infoData.value.car_records_list.forEach(item => {
              editForm.value.count += Number(item.count);
              infoData.value.car_records.count += Number(item.count);
            })
          }
          supplementRef.value.close();
          supplementRef.value.isLoading = false;
        }
      });
    }
    /**
     * 
     * 乘车记录-删除按钮
     * 
     * **/
    const onDelete = (row, i) => {
      infoData.value.car_records_list.splice(i, 1);
      editForm.value.count = 0;
      infoData.value.car_records.count = 0;
      if (infoData.value.car_records_list.length > 0) {
        infoData.value.car_records_list.forEach(item => {
          editForm.value.count += Number(item.count);
          infoData.value.car_records.count += Number(item.count);
        })
      }
    }

    /**
     * 
     * 提交
     * 
     * **/
    const handleSure = () => {
      let lists = [];
      if (isEditInfo.value) {
        ElMessage.error('请确认修改基本信息！');
        return;
      }
      if (infoData.value.car_records_list.length == 0) {
        ElMessage.error('请添加乘车记录！');
        return;
      } else {
        infoData.value.car_records_list.forEach(item => {
          if (!item.count) {
            ElMessage.error('请输入乘车人数！');
            return;
          }
          if (item.order_id) {
            lists.push({
              id: item.id,
              contact_name: item.contact_name,
              contact_mobile: item.contact_mobile,
              count: item.count,
              departure_place: item.departure_place,
              arrival_place: item.arrival_place,
              order_id: item.order_id,
            })
          } else {
            lists.push({
              id: item.id,
              contact_name: item.contact_name,
              contact_mobile: item.contact_mobile,
              count: item.count,
              departure_place: item.departure_place,
              arrival_place: item.arrival_place
            })
          }
        })
      }
      dialogRef.value.isLoading = true;
      let params = {
        id: currentRow.value.id,
        car_id: infoData.value.car_records.car_id,
        count: infoData.value.car_records.count,
        driver: infoData.value.car_records.driver,
        departure_time: infoData.value.car_records.departure_time,
        arrival_time: infoData.value.car_records.arrival_time,
        departure_place: infoData.value.car_records.departure_place,
        arrival_place: infoData.value.car_records.arrival_place,
        stopover_place: infoData.value.car_records.stopover_place,
        list: lists,
        req_type: 1,
      };
      VipApi.editCarRecords(params).then((res) => {
        dialogRef.value.isLoading = false;
        if (res.Code === 200) {
          emit("submit");
          ElMessage.success("编辑成功！");
          dialogRef.value.close();
        } else {
          ElMessage.error(res.Message);
        }
      });
    }
    const showSystemOrderListsTable = ref(false);

    return {
      openDialog,
      dialogRef,
      closeDialog,
      closeDialogLoading,
      currentRow,
      getDetailsData,
      infoData,
      tableRef,
      tableColumns,
      isEdit,
      handleSure,
      onDelete,
      onAddBtn,
      supplementRef,
      onSuresupplement,
      formRef,
      ruleForm,
      formRules,
      editFormRef,
      editForm,
      editFormRules,
      isEditInfo,
      onConfirmModify,
      driverOptions,
      getDriverOptions,
      onEditInfo,
      getAvailableCarList,
      carOptions,
      basicDatas,
      // countInput,
      onEditBtn,
      editIndex,
      showSystemOrderLists,
      onAddSystemBtn,
      systemOrderLists,
      orderSearchKeyword,
      filteredOrderList,
      handleOrderSearch,
      handleOrderSelect,
      showSystemOrderListsTable
    };
  },
};
</script>

<style lang="scss">
.operation-edit-dialog {
  .margin-left-10 {
    margin-left: 10px;
  }

  .outward-run {
    .outward-img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }

    .remain-seats {
      height: 60px;
      background-color: var(--search-bg-color);
      border-radius: 4px;
      padding: 0 15px;
    }

    .left-title {
      color: #92979E;
      width: 70px;
    }

    .left-content {
      color: #262C30;
    }
  }

  .add-btn {
    color: var(--theme-color);
    cursor: pointer;
  }

  .add-text {
    margin-left: 3px;
  }

  .count {
    margin-right: 20px;
  }

  .count-img {
    width: 18px;
    height: 18px;
    cursor: pointer;
    color: var(--theme-color);
  }

  .edit-info-form {
    .el-form-item {
      margin-bottom: 10px;
    }

    .el-form-item__label {
      color: #92979E;
      line-height: 38px;
    }
  }

  .order-search-container {
    .search-input-wrapper {
      position: relative;
      margin-bottom: 16px;

      .search-icon {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #c0c4cc;
        z-index: 10;
      }

      .order-search-input {
        .el-input__inner {
          padding-left: 40px;
          height: 40px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;

          &:focus {
            border-color: var(--theme-color);
          }
        }
      }
    }

    .order-table-container {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      overflow: hidden;

      .order-selection-table {
        .el-table__header {
          background-color: #f5f7fa;
        }

        .el-table__row {
          cursor: pointer;

          &:hover {
            background-color: #f5f7fa;
          }

          &.current-row {
            background-color: #e6f7ff;
          }
        }

        .el-table__cell {
          padding: 12px 0;
          font-size: 14px;
        }
      }
    }
  }
}
</style>